<template>
    <div>
        <canvas v-for="item in numPages" :key="item" :id="'pdf'+item"  />
    </div>
</template>
<script>
import pdfjsLib from 'pdfjs-dist';
export default {
    data(){
        return {
            numPages:0,
        }
    },
    props:['src'],
    mounted(){
        // pdfjsLib.cMapUrl= 'https://cdn.jsdelivr.net/npm/pdfjs/dist@2.0.288/cmaps/' 
        // pdfjsLib.cMapPacked= true 
        let loadingTask = pdfjsLib.getDocument(this.src);
        let _this = this;
        loadingTask.promise.then((pdf) => {
            this.numPages = pdf.numPages;
            for(let i = 1; i <= pdf.numPages; i++){
                pdf.getPage(i).then(function(page) {
                    console.log(page);
                    // var scale = 2; //缩放比例
                    // var viewport = page.getViewport(scale);
                    var viewport= page.getViewport(2.0);
                    var canvas = document.getElementById('pdf'+i);
                    var context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    canvas.style.width = '100%';
                    var renderTask = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    page.render(renderTask);
                    // return renderTask.promise;
                });
            }
            _this.$emit('loadingFun',false);
        });
    },
    methods:{
    }
}
</script>

